module.exports = __webpack_public_path__ + "static/media/luckyThree-4.992b8d38.png";